<template>
  <v-container>
    <v-row justify="center">
      <v-col md="4">
        <v-autocomplete v-model="selectedBuilding" label="Изберете сграда" :items="autocompleteValues"></v-autocomplete>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :top="true" :right="true" :vertical="true" color="success" :timeout="5000">
      Successfully deleted
      <v-btn dark text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-row justify="center">
      <v-dialog v-model="confirmDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Are you sure?</v-card-title>
          <v-card-text>Do you really want to delete these records? This process cannot be undone.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="cancel">Cancel</v-btn>
            <v-btn color="green darken-1" text @click="agree">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-card :elevation="3">
      <v-data-table
        :headers="headers"
        :items="entrances"
        :items-per-page="itemsPerPage"
        :page.sync="currentPage"
        :loading="tableLoading"
        :sort-by.sync="sortBy"
        :sort-desc.sync="descending"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <div class="flex-grow-1"></div>
            <v-btn color="indigo" dark class="mb-1" to="/entrances/create">
              Добави вход
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.title="props">
          {{ props.item.translations.title }}
        </template>
        <template v-slot:item.buildingId="props">
          {{ getBuildingTitle(props.item.buildingId) }}
        </template>
        <template v-slot:item.actions="props">
          <v-icon @click.native="handleEditClick(props.item.id)" small class="mr-2">mdi-pencil</v-icon>
          <v-icon @click.native="handleDeleteClick(props.item.id)" small>mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      tableLoading: true,
      selectedBuilding: null,
      itemsPerPage: 10,
      currentPage: 1,
      snackbar: false,
      sortBy: 'createdAt',
      descending: true,
      deleteId: null,
      confirmDialog: false,
      headers: [
        { text: 'Заглавие', sortable: false, value: 'title', width: '15%' },
        { text: 'Сграда', value: 'buildingId', width: '25%' },
        { text: 'Дата на създаване', value: 'createdAt' },
        { text: 'Последно редактиране', value: 'updatedAt' },
        { text: 'Actions', value: 'actions', sortable: false, align: 'right' }
      ]
    }
  },
  created () {
    this.$store.dispatch('fetchBuildings')
    this.$store.dispatch('fetchEntrances')
      .then(() => this.tableLoading = false)
  },
  computed: {
    buildings () {
      return this.$store.state.building.buildings
    },
    entrances () {
      return this.$store.getters.getBuildingEntrances(this.selectedBuilding)
    },
    autocompleteValues () {
      const buildings = [...this.buildings]
      return buildings.map(building => ({
        text: building.translations ? building.translations.title : '',
        value: building.id
      }))
    }
  },
  methods: {
    handleEditClick (id) {
      this.$router.push({ name: 'entrances-edit', params: { id } })
    },
    handleEntranceCreateClick () {
      this.buildingExistsSnackbar = false
      if (!this.selectedBuilding) {
        this.buildingExistsSnackbar = true
        return
      }

      this.$router.push({ path: `/entrances/create/${this.selectedBuilding }` })
    },
    getBuildingTitle (id) {
      const building = this.$store.getters.getBuilding(id)
      if (!building) {
        return ''
      }
      
      return building.translations ? building.translations.title : ''
    },
    handleDeleteClick (id) {
      this.confirmDialog = true
      this.deleteId = id
    },
    cancel () {
      this.confirmDialog = false
      this.deleteId = null
    },
    agree () {
      this.confirmDialog = false
      this.$store.dispatch('removeEntrance', this.deleteId)
        .then(res => {
          if (res.data.success) {
            this.snackbar = true
            this.$store.dispatch('fetchEntrances')

            this.deleteId = null
          }
        })
      }
  }
}
</script>

<style lang="scss" scoped>
.buildings-autocomplete {
  width: 100%;
  max-width: 400px;
}
</style>